import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1200Model } from '../kymw1200.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
export type GetCycleMediumSelectItemsResponse = {
  Code: string;
  Name: string;
}[];

/**
 * サイクル設定媒体選択項目取得サービス
 * @export GetCycleMediumSelectItemsService
 * @class GetCycleMediumSelectItemsService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCycleMediumSelectItemsService extends PlessJsonResponderSub<GetCycleMediumSelectItemsResponse> {
  model: KYMW1200Model;
  private succeed: () => void;
  private fail: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCycleMediumSelectItemsService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PastCycle: this.model.pastCycle,
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param f
   * @memberof GetCycleMediumSelectItemsService
   */
  execute(
    model: KYMW1200Model,
    s: () => void = null,
    f: () => void = null
  ): void {
    this.model = model;
    this.succeed = s;
    this.fail = f;
    this.send('getCycleMediumSelectItems', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCycleMediumSelectItemsService
   */
  success(data: GetCycleMediumSelectItemsResponse) {
    this.model.cycleMediumList = data;
    if (this.succeed) this.succeed();
  }

  /**
   * async/await 記述用
   *
   * @param model
   * @returns Promise<void>
   */
  public executeAsync(model: KYMW1200Model): Promise<void> {
    return new Promise((resolve, reject) => {
      this.execute(
        model,
        () => resolve(),
        () => reject()
      );
    });
  }

  protected statusError(status: string, result: any) {
    super.statusError(status, result);
    if (this.fail) this.fail();
  }
}
